module.exports = __webpack_public_path__ + "img/spotted-orange-lily.4ad48cc7.webp";